<template>
  <div class="mb-8">
    <h2 
      class="customTitle"
    >흡연 욕구 변화</h2>

    <v-progress-circular
      v-if="loading"
      indeterminate
      color="primary"
      class="mx-auto"
      style="display: block;"
    ></v-progress-circular>

    <div v-else>
      <v-chip-group
        v-model="selectedRange"
        class="historyProgressButtonBox"
        active-class="primary--text"
        column
        mandatory
      >
        <v-chip class="customButton" value="7"> 7일 </v-chip>
        <v-chip class="customButton" value="14"> 14일 </v-chip>
        <v-chip class="customButton" value="30"> 30일 </v-chip>
      </v-chip-group>
      <LineChart 
        v-if="desireList != undefined && desireList != '' && desireList != null" 
        :data="desireList"
      ></LineChart>
      <div 
        v-else
        class="contentsNone"
      >
        <p class="mb-2">
          <v-icon>mdi-alert</v-icon>
        </p>
        <div class="text-center">변화 기록이 없습니다.</div>
      </div>
    </div>
  </div>
</template>
<script>
import LineChart from './LineChart';

export default {
  name: "Progress",
  data() {
    return {
      selectedRange: undefined,
      desireList: undefined,
      loading: true,
    };
  },
  components: {
    LineChart,
  },
  watch: {
    selectedRange(v) {
      this.getData();
    },
  },
  computed: {
    challengeId() {
      return this.$store.getters.challengeId;
    },
  },
  methods: {
    getData() {
      this.loading = true;
      this.desireList = undefined;
      // this.$axios
      //   .get(
      //     "/challenges/" +
      //       this.challengeId +
      //       "/desire?range=" +
      //       this.selectedRange
      //   )
      //   .then((response) => {
      //     this.desireList = response.data;
      //     this.loading = false;
      //   });
      this.desireList = [
        {
          challenge_date: "2023-08-01",
          desire_percentage: 40
        },
         {
          challenge_date: "2023-08-02",
          desire_percentage: 27
        },
         {
          challenge_date: "2023-08-03",
          desire_percentage: 78
        },
         {
          challenge_date: "2023-08-04",
          desire_percentage: 72
        },
         {
          challenge_date: "2023-08-05",
          desire_percentage: 51
        },
         {
          challenge_date: "2023-08-06",
          desire_percentage: 75
        },
      ];
      this.loading = false;
    },
  },
  mounted(){
    this.selectedRange = 7;
  }
};
</script>
<style lang="scss">
.historyProgressButtonBox{
  margin-bottom: 28px;

  &.v-chip-group--column .v-slide-group__content{
    display: flex;
    align-items: center;
    justify-content: space-between;
  
    .customButton{
      justify-content: center;
      margin: 0;

      &.v-chip--active{
        color: #fff !important;
        background-color: #ffb5cc;
      }
    }
  }
}
</style>